
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/interest-calculator",
      function () {
        return require("private-next-pages/interest-calculator.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/interest-calculator"])
      });
    }
  